import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { IReportModel } from "../../services/reporting-data-service/Models";
import ReportingDataService from "../../services/reporting-data-service/ReportingDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseReportDeferredDataQueryParameters = {
    groupID: number;
    fileStoreID: number;
} & BaseUseQueryParameters<IReportModel>;

export function useReportDeferredData({
    groupID,
    fileStoreID,
    enabled,
    onError,
    onSuccess,
}: UseReportDeferredDataQueryParameters) {
    return useQuery<IReportModel | undefined, RestError>(
        keys.deferredData(
            groupID,
            fileStoreID
        ),
        ({ signal }) => {
            return ReportingDataService.getReportDeferredData(
                groupID,
                fileStoreID,
                signal
            );
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
            staleTime: 0
        }
    );
}
